import { QueryClient } from "@tanstack/react-query";
import { LoaderFunctionArgs } from "react-router";
import { INTERVIEWS_QUERIES } from "~/shared/api/interviews/interviews.queries";

export function editInterviewViewLoader(queryClient: QueryClient, { params }: LoaderFunctionArgs) {
  const { interviewId } = params;

  if (!interviewId) {
    throw new Error("Interview ID is required to load interview");
  }

  // Prefetch the interview data and store it in the client cache.
  queryClient.prefetchQuery(INTERVIEWS_QUERIES.detail(interviewId));

  return null;
}
